import clsx from 'clsx';
import { Icon } from 'common/icon';
import styles from './styles.module.css';

type Props = {
  isOpen?: boolean;
  type?: 'solid' | 'line';
  size?: 'small' | 'medium';
  fill?: string;
};

export const SelectArrow = ({
  isOpen,
  type = 'line',
  size = 'medium',
  fill,
}: Props) => {
  return (
    <div
      className={clsx({
        [styles.arrow_size_small]: size === 'small',
        [styles.arrow_size_medium]: size === 'medium',
        [styles.open]: isOpen,
        [styles.close]: !isOpen,
      })}
    >
      {type === 'line' && <Icon.ArrowLeft fill={fill} />}
      {type === 'solid' && (
        <Icon.ArrowSolid
          width={size === 'small' ? 10 : 20}
          height={size === 'small' ? 10 : 20}
          fill={fill}
        />
      )}
    </div>
  );
};
